class Video {
	constructor(config) {
		this.config = Object.assign({
			scope: '[data-video="scope-video-component"]',
			video: '[data-video="video"]',
			play: '[data-video="play"]',
			thumbnail: '[data-video="thumbnail"]',
			blacklist: 'a[href], [data-fancybox]',
			initialized: 'video-initialized'
		}, config);

		this.scope = document.querySelectorAll(`${this.config.scope}:not(.${this.config.initialized})`);

		if (this.scope.length > 0) {
			this.init()
		}
	}

	init() {
		this.scope.forEach(scope => {
			if (this.videoIsChildOfAnchorElement(scope)) {
				this.alterAnchorLink(scope);
				this.alterFancybox(scope);
				return;
			}

			const btn = scope.querySelector(this.config.play);
			if (!btn) {
				return
			};

			if (scope.dataset.thumbnailId) {
				const video = scope.querySelector(this.config.video);
				video.style.display = 'none';
			}

			btn.addEventListener('click', () => this.handleClick(scope));

			scope.classList.add(this.config.initialized);
		});
	}

	videoIsChildOfAnchorElement(scope) {
		return !!scope.closest(this.config.blacklist);
	}

	alterFancybox(scope) {
		const fancybox = scope.closest('[data-fancybox]');
		if (!fancybox) return;
		fancybox.addEventListener('click', () => {
			scope.querySelector(this.config.video)?.pause();
		});

		const src = scope.querySelector(this.config.video)?.dataset.src;
		if (src) fancybox.href = src;
	}

	alterAnchorLink(scope) {
		const anchor = scope.closest('a[href]:not([data-fancybox])');
		if (!anchor) return;
		this.removeVideoComponentElements(scope);
	}

	removeVideoComponentElements(scope) {
		const btn       = scope.querySelector(this.config.play);
		const overlay   = scope.querySelector('.x-video-overlay');
		const thumbnail = document.querySelector(scope.dataset.thumbnailId);

		btn?.remove();
		overlay?.remove();
		thumbnail?.remove();
	}

	handleClick(scope) {
		const video     = scope.querySelector(this.config.video);

		video?.style.removeProperty('display');
		video?.setAttribute('controls', 'controls');
		video?.play();
		this.removeVideoComponentElements(scope);
	}
}

export default Video;
